export default __webpack_public_path__ + "static/media/fb_laptop_normal.eebaca16.png";